import React, { useState, useEffect } from "react";

const Countdown = ({ seconds }) => {
  const [count, setCount] = useState(seconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return <p>Page will reload in {count > 0 ? count : "1"} seconds ...</p>;
};

export default Countdown;
